<h3 *ngIf="label" class="mat-h3">{{ label }}<span *ngIf="isRequired(control)"> *</span></h3>

<mat-radio-group
  *ngIf="!isMultiselect"
  [formControl]="control"
  [fxLayout]="layout"
  [fxLayout.xs]="'column'"
  fxFlexAlign="center space-between"
  [fxLayoutGap]="layoutGap"
>
  <mat-radio-button
    *ngFor="let option of options"
    color="primary"
    [fxFlex]="100 / options.length"
    [value]="option.value"
  >
    {{ option.name }}
  </mat-radio-button>
</mat-radio-group>

<mat-selection-list
  *ngIf="isMultiselect"
  [formControl]="control"
  [fxLayout]="layout"
  fxFlexAlign="center space-between"
  [fxLayoutGap]="layoutGap"
>
  <mat-list-option
    class="mat-list-option"
    *ngFor="let option of options"
    [fxFlex]="100 / options.length"
    [value]="option.value"
    checkboxPosition="before"
    color="primary"
    [ngClass]="{ 'hidden-option': hiddenOptions.includes(option.name) }"
  >
    {{ option.name }}
  </mat-list-option>
</mat-selection-list>

<mat-error class="mat-error"><wai-form-error class="mat-error" [formField]="control"></wai-form-error></mat-error>
